import React from 'react';
import { Box, Typography } from '@mui/material';

const InfoRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
    <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
      {value || '--'}
    </Typography>
  </Box>
);

const ProfileOfficial = ({ empData, deps, desigs, shifts }) => {
  // Helper functions to map IDs to Names
  const getDepName = (id) => deps.find(d => d.id === id)?.name || id || '--';
  const getDesigName = (id) => desigs.find(d => d.id === id)?.name || id || '--';
  const getShiftName = (id) => shifts.find(s => s.id === id)?.shift_name || id || '--';

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', mb: 3, borderBottom: '2px solid #E2E8F0', pb: 1.5 }}>
        Official Information
      </Typography>
      
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 3 }}>
        <InfoRow label="Employee ID" value={empData.emp_id} />
        <InfoRow label="Department" value={getDepName(empData.department_id)} />
        <InfoRow label="Designation" value={getDesigName(empData.designation_id)} />
        
        <InfoRow label="Date of Joining" value={empData.date_of_joining} />
        <InfoRow label="Employee Level" value={empData.employee_level} />
        <InfoRow label="Role" value={empData.role} />
        
        <InfoRow label="Official Email" value={empData.official_email} />
        <InfoRow label="L1 Approver" value={empData.leave_approver_l1} />
        <InfoRow label="L2 Approver" value={empData.leave_approver_l2} />
        
        <InfoRow label="Shift" value={getShiftName(empData.shift_id)} />
        <InfoRow label="Status" value={empData.status} />
      </Box>
    </Box>
  );
};

export default ProfileOfficial;